import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { BoletoComponent } from './boleto/boleto.component';
import { Error404Component } from './error404/error404.component';
import { PDFComponent } from './boleto/pdf.component';
import { EnvServiceProvider } from './env/env.service.provider';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RecaptchaModule } from "ng-recaptcha";


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    Error404Component,
    BoletoComponent,
    PDFComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    PopoverModule.forRoot(),
    FormsModule,
    NgxMaskModule.forRoot({ validation: true } as Partial<IConfig>),
    RecaptchaModule,
    RouterModule.forRoot([
      { path: '', redirectTo: 'boleto', pathMatch: 'full' },
      { path: 'boleto', component: BoletoComponent, pathMatch: 'full' },
      {path:'boleto/PDF',component: PDFComponent},
      { path: '**', component: Error404Component }
    ])
  ],
  providers: [EnvServiceProvider, { provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
